export default class TenantInitDataPO{
    tenantId:number;
    itemId:string;
    typeId:number;
    targetId:number[];
    isAll:boolean;
}